<mat-toolbar *ngIf="!isAuthScreen()" [ngClass]="{ 'hide-for-printing': isPrintMode() }">
    @if (isAuthenticated$ | async) {
    <button mat-icon-button class="menu-toggle" aria-label="Menu icon" (click)="toggleSideNav()">
        <mat-icon>menu</mat-icon>
    </button>
    }
    <div class="app-header">
        <div class="app-identity" i18n>
            <h1 class="study-name">{{ selectedStudy.studyName ? selectedStudy.studyName : 'BioPlex 2200 Data Analysis' }}</h1>
            @if (isStudyCommitted) {
            <span class="committed-chip">Committed</span>
            }
            @if (isAuthenticated$ | async) {
            <div class="status-slot" role="status" aria-label="Calculation status">
                <ng-container *ngIf="isProcessing; else showStatus">
                    <span class="status-chip status-chip--busy">
                        <span class="spinner"></span>
                        {{ processingLabel }}
                    </span>
                </ng-container>
                <ng-template #showStatus>
                    <ng-container *ngIf="loadStudyError; else showCalcStatus">
                        <span class="status-chip status-chip--fail">Error loading study</span>
                    </ng-container>
                    <!-- Nothing is rendered for the resting NA state: an empty verdict is not news. -->
                    <ng-template #showCalcStatus>
                        <button
                            *ngIf="calculationStatus === 'FAIL' || calculationStatus === 'ALERT' || calculationStatus === 'PASS'"
                            type="button"
                            class="status-chip status-chip--action status-button"
                            [ngClass]="{
                                'status-chip--pass': calculationStatus === 'PASS',
                                'status-chip--alert': calculationStatus === 'ALERT',
                                'status-chip--fail': calculationStatus === 'FAIL'
                            }"
                            (click)="openStatusSummaryDialog()"
                            aria-label="Calculation status">
                            {{ calculationStatus }}
                        </button>
                    </ng-template>
                </ng-template>
            </div>
            }
        </div>
        @if (isAuthenticated$ | async) {
        <div class="app-actions new-study-box">
          <div class="status-banner status-banner--samples" *ngIf="showSampleDataBanner$ | async">
            <span class="status-banner__dot"></span>
            <span>Fetching latest samples…</span>
          </div>
          <div class="status-banner status-banner--workbook" *ngIf="showWorkbookExportBanner$ | async">
            <span class="status-banner__dot"></span>
            <span>Exporting workbook…</span>
          </div>
          <div class="status-banner status-banner--report" *ngIf="showReportDownloadBanner$ | async">
            <span class="status-banner__dot"></span>
            <span>Generating report…</span>
          </div>
          <mat-button-toggle-group class="study-toggle"
                                   name="study"
                                   [hideSingleSelectionIndicator]="true">
           <mat-button-toggle checked (click)="loadNewStudy()">New Study</mat-button-toggle>
           <mat-button-toggle (click)="loadStudy()">Load Study</mat-button-toggle>
          </mat-button-toggle-group>
          <span class="app-actions__sep" aria-hidden="true"></span>
          <button mat-ripple type="button" class="hdr-btn save-button" (click)="saveStudy()" [disabled]="isStudyCommitted">Save</button>
          <button mat-ripple type="button" class="hdr-btn commit-button" (click)="commitStudy()" [disabled]="!(selectedStudy && selectedStudy.studyId && selectedStudy.studyName && isCalculateEnabled) || (isSuperUser$ | async) === false || isStudyCommitted">Commit</button>
          <span class="app-actions__sep" aria-hidden="true"></span>
          <button mat-ripple type="button" class="hdr-btn hdr-btn--primary calculate-button" (click)="calculate('CalculateWithOutAdjustment')" [disabled]="(!isCalculateEnabled || isProcessing) || shouldDisableNormalCalculate() || isStudyCommitted">Calculate</button>
          <button mat-ripple type="button" class="hdr-btn calculate-button" (click)="calculate('CalculateWithAdjustment')" [disabled]="(!isCalculateEnabled || isProcessing) || shouldDisableAdjustedCalculate() || isStudyCommitted">Calculate wADJ</button>        </div>
        }
    </div>
</mat-toolbar>

<mat-sidenav-container autosize [ngClass]="{ 'hide-for-printing': isPrintMode(), 'shell--auth': isAuthScreen() }">
    @if (isAuthenticated$ | async) {
    <mat-sidenav #sidenav [opened]="true" mode="side">
      <mat-nav-list class="menu-list">
        @for (route of routes; track route) {
        @if (!!route.data && route.path !== 'logout') {
        <!-- Wrapped in an object so the block renders even while `visible` is false or not yet emitted. -->
        @if ({ visible: menuRouteVisible(route) | async }; as nav) {
        <a mat-list-item
  [routerLink]="nav.visible ? (route.path || null) : null"
  routerLinkActive="menu-item-active"
  (click)="onMenuClick($event, route)"
  [attr.aria-disabled]="nav.visible === false"
  [attr.title]="nav.visible === false && isDisabledRoute(route) ? 'Available once the study has been calculated' : null"
  [style.pointer-events]="nav.visible === false ? 'none' : null"
  [class.disabled]="nav.visible === false && isDisabledRoute(route)">
  <span class="menu-link"
        [class.is-disabled]="nav.visible === false && isDisabledRoute(route)">
    {{ route.title }}
  </span>
</a>
        }
        <!-- Everything below Run Info unlocks only once the study has been calculated. -->
        @if (route.path === 'run') {
        <div class="menu-divider" aria-hidden="true"></div>
        }
        }
        }
        <div class="menu-footer">
          <a mat-list-item class="sidebar-about" routerLink="/about">
            <span class="menu-link">About</span>
          </a>
          <a mat-list-item class="sidebar-logout" routerLink="/logout" routerLinkActive="menu-item-active">
            <span class="menu-link">Log Out</span>
          </a>
        </div>
      </mat-nav-list>
    </mat-sidenav>
    }
    <mat-sidenav-content>
      <div class="m-6 nav-container">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
</mat-sidenav-container>

<router-outlet name="print"></router-outlet>
